import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import logo from "../../assets/img/EHN-Online-Logo.png";
import { features } from "../../config/features";
import {
  login,
  forgotPassword,
  changeUserLang,
} from "../../actions/account.action";
import notification from "../../services/notification-service";
import localizationService from "../../services/localization-service";
import {
  openAssessmentModal,
  openRequestModal,
  openTextMessagesModal,
  openDisclaimerModal,
  openVerificationModal,
  getAssessments,
} from "../../actions/portal.action";
import { useNavigate, useLocation } from "react-router-dom";
import MoonLoader from "react-spinners/MoonLoader";
import packageJson from "../../../package.json";
import config from "../../config";

export const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedlang = useSelector((state) => state.account.lang);
  const [isSetOrResetAccount, setResetOrAcc] = useState({
    resetPass: false,
    setAccount: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isDesktopResolution, setIsDesktopResolution] = useState(true);
  const [stayLoggedIn, setStayLoggedIn] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 500) {
      setIsDesktopResolution(false);
      let body = document.querySelector("body");

      body.classList.remove("bg-gray-50");
      body.classList.add("white-background");
    }
  }, []);

  const {
    register: loginRegister,
    handleSubmit: handleLoginSubmit,
    formState: { errors: loginErrors },
  } = useForm({ mode: "onSubmit" });
  

  const {
    register: forgotRegister,
    handleSubmit: handleForgotSubmit,
    reset: resetForgot,
    formState: { errors: forgotErrors },
  } = useForm({ mode: "onSubmit" });

  const loginSubmiting = useSelector((state) => state.account.loginSubmiting);
  const forgotPasswordSubmiting = useSelector(
    (state) => state.account.forgotPasswordSubmiting,
  );
  const onSubmit = (values) => {
    if (stayLoggedIn) {
      const expirationTime =
        new Date().getTime() + config.STAY_LOGGED_IN_HOURS * 60 * 60 * 1000;
      localStorage.setItem(
        config.STAY_LOGGED_IN_UNTIL,
        expirationTime.toString(),
      );
    } else {
      localStorage.removeItem(config.STAY_LOGGED_IN_UNTIL);
    }

    dispatch(login(values.email, values.password, stayLoggedIn))
      .then((result) => {
        notification.success(
          localizationService.getLocalizationValue(
            "portalLoginSuccess",
            result.Lang,
          ),
        );

        if (result.HasRequest === true) {
          dispatch(openRequestModal());
        }

        if (result.HasDisclaimer === true) {
          localStorage.removeItem(config.DISCLAIMER_ACCEPTED);
          dispatch(openDisclaimerModal());
        } else {
          localStorage.setItem(config.DISCLAIMER_ACCEPTED, "true");
        }

        dispatch(getAssessments())
          .then((assessmentResult) => {
            if (assessmentResult && assessmentResult.length > 0) {
              dispatch(openAssessmentModal());
            }

            setTimeout(() => {
              navigate("/", { replace: true });
            }, 100);
          })
          .catch((error) => {});

        // Open verification modal until client has AllSent (3) or Verified (4)
        if (features.identityVerification && result.VerificationStatus !== 3 && result.VerificationStatus !== 4) {
          dispatch(openVerificationModal());
        }

        // Here should be logic for checking if textMessages modal should be opened
      })
      .catch((error) => {
        notification.error(
          localizationService.getLocalizationValue(
            "invalidPassCombination",
            selectedlang,
          ),
        );
      });
  };

  let body = window.document.body;
  body.classList.add("login-page");
  const onForgot = (values) => {
    dispatch(forgotPassword(values.email))
      .then(() => {
        notification.success(
          localizationService.getLocalizationValue(
            "emailSentSuccess",
            selectedlang,
          ),
        );
        setResetOrAcc({
          resetPass: false,
          setAccount: false,
        });
      })
      .catch((error) => {
        notification.error(
          localizationService.getLocalizationValue(
            "invalidEmail",
            selectedlang,
          ),
        );
      });
  };

  const changeLang = (lang) => {
    dispatch(changeUserLang(lang));
  };
  const cancel = () => {
    resetForgot();
    setResetOrAcc({
      resetPass: false,
      setAccount: false,
    });
  };
  const resetPassword = () => {
    setResetOrAcc({
      resetPass: true,
      setAccount: false,
    });
  };
  const setAccount = () => {
    setResetOrAcc({
      resetPass: false,
      setAccount: true,
    });
  };

  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <section
      className={`min-h-screen ${isDesktopResolution ? "bg-gradient-to-br from-gray-50 to-gray-100" : ""}  flex items-center justify-center p-4`}
    >
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center transition-opacity duration-300 ${
          loginSubmiting ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <MoonLoader
          color="#9aa82d"
          size={80}
          loading={loginSubmiting}
          aria-label="Loading Spinner"
        />
      </div>

      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center transition-opacity duration-300 ${
          forgotPasswordSubmiting
            ? "opacity-100"
            : "opacity-0 pointer-events-none"
        }`}
      >
        <MoonLoader
          color="#9aa82d"
          size={80}
          loading={forgotPasswordSubmiting}
          aria-label="Loading Spinner"
        />
      </div>

      <div
        className={`w-full max-w-md bg-white space-y-6 ${
          isDesktopResolution ? "rounded-2xl shadow-xl p-8" : "px-1"
        }`}
      >
        <div className="flex justify-end space-x-2 text-sm">
          <button
            type="button"
            onClick={() => changeLang("en-CA")}
            className={`${
              selectedlang === "en-CA"
                ? "text-primary font-medium"
                : "text-gray-400 hover:text-gray-600"
            }`}
          >
            EN
          </button>
          <span className="text-gray-300">|</span>
          <button
            type="button"
            onClick={() => changeLang("fr-CA")}
            className={`${
              selectedlang === "fr-CA"
                ? "text-primary font-medium"
                : "text-gray-400 hover:text-gray-600"
            }`}
          >
            FR
          </button>
        </div>

        {isSetOrResetAccount.resetPass === false &&
        isSetOrResetAccount.setAccount === false ? (
          <form onSubmit={handleLoginSubmit(onSubmit)} className="space-y-6">
            <div className="flex justify-center">
              <img src={logo} alt="Logo" className="w-auto" />
            </div>

            <div className="space-y-4">
              <div>
                <label htmlFor="email" className="sr-only">
                  {localizationService.getLocalizationValue(
                    "successResetEmailSecond",
                    selectedlang,
                  )}
                </label>
                <input
                  name="email"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-200"
                  placeholder={localizationService.getLocalizationValue(
                    "successResetEmailSecond",
                    selectedlang,
                  )}
                  {...loginRegister("email", {
                    required: localizationService.getLocalizationValue(
                      "required",
                      selectedlang,
                    ),
                  })}
                  autoFocus
                />
                {loginErrors.email && (
                  <p className="mt-1 text-sm text-red-600">
                    {loginErrors.email.message}
                  </p>
                )}
              </div>

              <div className="relative">
                <label htmlFor="password" className="sr-only">
                  {localizationService.getLocalizationValue(
                    "password",
                    selectedlang,
                  )}
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-200"
                  placeholder={localizationService.getLocalizationValue(
                    "password",
                    selectedlang,
                  )}
                  {...loginRegister("password", {
                    required: localizationService.getLocalizationValue(
                      "required",
                      selectedlang,
                    ),
                  })}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors duration-200"
                >
                  <i
                    className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
                  />
                </button>
                {loginErrors.password && (
                  <p className="mt-1 text-sm text-red-600">
                    {loginErrors.password.message}
                  </p>
                )}
              </div>
            </div>

            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="stayLoggedIn"
                checked={stayLoggedIn}
                onChange={(e) => setStayLoggedIn(e.target.checked)}
                className="w-4 h-4 mt-0.5 text-[#9aa82d] bg-gray-100 border-gray-300 rounded focus:ring-[#9aa82d] focus:ring-2"
              />
              <label
                htmlFor="stayLoggedIn"
                className="text-sm text-gray-700 cursor-pointer leading-tight mb-0"
              >
                {localizationService
                  .getLocalizationValue("stayLoggedInForHours", selectedlang)
                  .replace("{hours}", config.STAY_LOGGED_IN_HOURS)}
              </label>
            </div>

            <button
              type="submit"
              className="w-full py-3 px-4 bg-[#9aa82d] hover:bg-[#7d8a1f] text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2"
            >
              <i className="fal fa-sign-in" />
              <span>
                {localizationService.getLocalizationValue(
                  "login",
                  selectedlang,
                )}
              </span>
            </button>

            <div className="flex flex-col space-y-2">
              <button
                type="button"
                onClick={() => resetPassword()}
                className="text-sm text-primary hover:text-primary-dark transition-colors duration-200"
              >
                {localizationService.getLocalizationValue(
                  "forgotPasswordBtn",
                  selectedlang,
                )}
                ?
              </button>
              <button
                type="button"
                onClick={() => setAccount()}
                className="text-sm text-primary hover:text-primary-dark transition-colors duration-200"
              >
                {localizationService.getLocalizationValue(
                  "createAccBtn",
                  selectedlang,
                )}
              </button>
            </div>
          </form>
        ) : (
          <form onSubmit={handleForgotSubmit(onForgot)} className="space-y-6">
            <div className="flex justify-center">
              <img src={logo} alt="Logo" className="w-auto" />
            </div>

            <h1 className="text-2xl font-semibold text-gray-900 text-center">
              {isSetOrResetAccount.resetPass
                ? localizationService.getLocalizationValue(
                    "resetPasswordTitle",
                    selectedlang,
                  )
                : localizationService.getLocalizationValue(
                    "createAccBtn",
                    selectedlang,
                  )}
            </h1>

            <div>
              <label htmlFor="email" className="sr-only">
                {localizationService.getLocalizationValue(
                  "successResetEmailSecond",
                  selectedlang,
                )}
              </label>
              <input
                name="email"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-200"
                placeholder={localizationService.getLocalizationValue(
                  "successResetEmailSecond",
                  selectedlang,
                )}
                {...forgotRegister("email", {
                  required: localizationService.getLocalizationValue(
                    "required",
                    selectedlang,
                  ),
                })}
                autoFocus
              />
              {forgotErrors.email && (
                <p className="mt-1 text-sm text-red-600">
                  {forgotErrors.email.message}
                </p>
              )}
            </div>

            <div className="flex space-x-4">
              <button
                type="submit"
                className="flex-1 py-3 px-4 bg-[#9aa82d] hover:bg-[#7d8a1f] text-white font-medium rounded-lg transition-colors duration-200"
              >
                {localizationService.getLocalizationValue(
                  "sendEmailBtn",
                  selectedlang,
                )}
              </button>
              <button
                type="button"
                onClick={() => cancel()}
                className="flex-1 py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200"
              >
                {localizationService.getLocalizationValue(
                  "cancel",
                  selectedlang,
                )}
              </button>
            </div>
          </form>
        )}

        <p className="text-center text-sm text-gray-500">
          &copy; {getCurrentYear()} onthewagon.ca.{" "}
          {localizationService.getLocalizationValue(
            "rightsReserved",
            selectedlang,
          )}
          . v{packageJson.version}
        </p>
      </div>
    </section>
  );
};
